import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import Button from "../Component/Button";
import GreyLine from "../Component/GreyLine";
// import {resetMyReducer}
import Heading from "../Component/Heading";
import LineComp from "../Component/LineComp";
import {
  FormPageAction,
  TrialDateAction,
  resetState,
  restCouponDetailAction,
  setStartDateParam,
  userDetailAction,
} from "../Component/Redux/Feature/UrlSlice";
import axios from "axios";
import {
  appAction,
  contactAction,
  emailAction,
} from "../Component/Redux/Feature/EmailSlice";
import DateInput from "../Component/DateInput";
import { getContentData } from "../Utils/content";
import { appname } from "../Utils/constants";
import useSessionDetails from "../useSessionDetails";



const HomeContentNew = (props) => {
  const [selectedDateParam, setSelectedDateParam] = useState("");
  const [selectedDateEnable, setSelectedDateEnable] = useState(false);

  const {
    isTrial,
    trialDaysTime,
    paidDaysTime,
  } = useSessionDetails();


  // const [dateDisabled, setDateDisabled] = useState(false);

  const [startDateAvailable, setStartDateAvailable] = useState(false);

  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(window.location.search);
  const emailParam = queryParams.get("email");
  const appStatus = queryParams.get("app");

  const contactParams = queryParams.get("contact");

  useEffect(() => {

    dispatch(restCouponDetailAction());

    const queryParams = new URLSearchParams(window.location.search);
    const startDateParam = queryParams.get("startdate");


    if (startDateParam) {
     
      dispatch(setStartDateParam(startDateParam))
      
      setSelectDate(startDateParam)
     
      setSelectedDateParam(startDateParam);

      console.log("start date param => ", queryParams.get("startdate"));
      setSelectedDateEnable(true);
      // setDateDisabled(true);
      // setStartDateAvailable(true)
    } else {
      setSelectedDateParam("");
      // setDateDisabled(false);
      // setStartDateAvailable(false)
    }
  }, []);

  if (queryParams.get("email")) dispatch(emailAction(emailParam));
  if (queryParams.get("contact")) dispatch(contactAction(contactParams));
  if (queryParams.get("app")) dispatch(appAction(appStatus == "true"));

  if (queryParams.get("email") && queryParams.get("contact"))
    dispatch(
      FormPageAction({
        email: emailParam,
        phone: contactParams,
      })
    );

  const storeSel = useSelector((state) => state);
  const sessionContent = storeSel.UrlData.sessionList.sessions;

  const sessionTrialContent = storeSel.UrlData.sessionTrialList.sessionsTrial;
  const sessionsLoading = storeSel.UrlData.sessionsLoading;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const [selectedOption, setSelectedOption] = useState(0);
  const [selectedTrialOption, setSelectedTrialOption] = useState(0);
  const [selectdate, setSelectDate] = useState(storeSel.UrlData.startDateParam || "");
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [selectedPlanName, setSelectedPlanName] = useState(null);

  const [selectedSessionType, setSelectedSessionType] = useState(null);

  //  useEffect(() => {window.location.reload()},[])
  
  const handleSessionTypeChange = (sessionType) => {
    setSelectedSessionType(sessionType);
    var startDateFocus = document.getElementsByClassName("home-input");
    startDateFocus[0].focus();
    const index = parseInt(sessionType.split("_")[1]);

    if (sessionType.startsWith("trial_")) {
      setSelectedTrialOption(index);
    } else if (sessionType.startsWith("paid_")) {
      setSelectedOption(index);
    }
  };

  // ---------------Trial section functionality -----------------------------------------------------------------------------

  const handleTrialDateChange = (date) => {
    // Handle the change of trial date here
    setSelectDate(date); // Example: setSelectDate is a state updater function

    console.log("Selected date --> 11", date);
  };

  // const onSubmit = handleSubmit((data) => console.log(data));
  const onSubmit2 = handleSubmit((data) => console.log(data));

  const navigateTo = () => {
    // let expirydate = new Date(
    //   selectdate !== "" ? selectdate?.toISOString() : selectedDateParam?.toISOString()
    // );

    let expirydate = new Date(
      selectdate !== "" ? `${selectdate}T00:00:00` : `${selectedDateParam}T00:00:00`
    );

    console.log("Expiry date -->", expirydate, selectdate);

    expirydate.setDate(
      expirydate.getDate() +
        Number(
          selectedSessionType.startsWith("trial_")
            ? sessionTrialContent[selectedTrialOption]?.daystime
            : sessionContent[selectedOption]?.daystime
        )
    );

    let date_ob = new Date(expirydate);
    let date = ("0" + date_ob.getDate()).slice(-2);
    let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
    let year = date_ob.getFullYear();
    expirydate = year + "-" + month + "-" + date;

    dispatch(
      userDetailAction({
        planname: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.planname
          : sessionContent[selectedOption]?.planname,
        planid: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.planid
          : sessionContent[selectedOption]?.planid,
        sessionid: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.sessionid
          : sessionContent[selectedOption]?.sessionid,
        basecost: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.basecost
          : sessionContent[selectedOption]?.basecost,
        sumcost: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.sumcost
          : sessionContent[selectedOption]?.sumcost,
        ogTotal: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.sumcost
          : sessionContent[selectedOption]?.sumcost,
        taxcost: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.taxcost
          : sessionContent[selectedOption]?.taxcost,
        ogTaxes: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.taxcost
          : sessionContent[selectedOption]?.taxcost,
        taxpercent: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.taxpercent
          : sessionContent[selectedOption]?.taxpercent,
        false_cost: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.false_cost
          : sessionContent[selectedOption]?.false_cost,
        startdate: selectdate !== "" ? selectdate : selectedDateParam,
        name: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.name
          : sessionContent[selectedOption]?.name,
        expirydate: expirydate,
        max_sessions: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.max_sessions
          : sessionContent[selectedOption]?.max_sessions,
        branchid: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.branch_id
          : sessionContent[selectedOption]?.branch_id,
        daystime: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.daystime
          : sessionContent[selectedOption]?.daystime,
        isTrial: selectedSessionType.startsWith("trial_")
          ? sessionTrialContent[selectedTrialOption]?.istrial
          : sessionContent[selectedOption]?.istrial,
      })
    );

    navigate("form");
  };

// if(!sessionsLoading && sessionContent?.length == 0) return (<Navigate to="NotFound" />)
if(sessionsLoading) return<p>Loading...</p>

if(!sessionsLoading && sessionContent)
  return (
    <>
      <div className="home-content-container">
        <div className="logo-nav">
          {/* <p className="logo-nav-first-text">BODYPROCOACH</p>
          <p>{`>`}</p> */}
          {/* <p className="logo-nav-sweat-text">{sessionContent[0]?.planname}</p> */}
          <p className="logo-nav-sweat-text">Sweat Fit Wellness</p>
        </div>

        <div className="all-session-div">
          {/* {sessionsLoading && <p>Loading...</p>} */}
          <form onSubmit={handleSubmit(onSubmit2)} className="home-form">
            <div className="home-form-input">
              <label>Select Class Pack</label>
              <div className="radio-options">
                {!sessionsLoading &&
                  sessionTrialContent &&
                  sessionTrialContent.map((sess, index) => {
                    return (
                      <label
                        key={index}
                        className={`radio-box ${
                          selectedSessionType === `trial_${index}`
                            ? "selected"
                            : ""
                        }`}
                      >
                        <input
                          type="radio"
                          name="sessionType"
                          value={`trial_${index}`}
                          checked={selectedSessionType === `trial_${index}`}
                          onChange={() => {
                            handleSessionTypeChange(`trial_${index}`);
                            setSelectedPrice(sess.sumcost);
                            setSelectedPlanName(sess.name);
                          }}
                        />
                        <p className="plan-name-text">{sess.name} </p>
                        <p className="plan-price">
                          ₹{sess.sumcost}{" "}
                          {/* <span className="false-cost-para">
                            ₹{sess.false_cost}
                          </span> */}
                        </p>
                        <p className="plan-validity">
                          Validity: {sess.daystime} days
                        </p>
                        <p className="plan-validity">
                          {" "}
                          ₹
                          {sess.max_sessions
                            ? Math.floor(sess.sumcost / sess.max_sessions)
                            : "-"}{" "}
                          per session
                        </p>
                      </label>
                    );
                  })}

                {!sessionsLoading &&
                  sessionContent &&
                  sessionContent.map((sess, index) => {
                    return (
                      <label
                        key={index}
                        className={`radio-box ${
                          selectedSessionType === `paid_${index}`
                            ? "selected"
                            : ""
                        }`}

                        // style={{borderColor: `${
                        //   selectedSessionType === `paid_${index}`
                        //     ? "var(--global-theme)"
                        //     : ""
                        // }` }}
                      >
                        <input
                          type="radio"
                          name="sessionType"
                          value={`paid_${index}`}
                          checked={selectedSessionType === `paid_${index}`}

                          //     onChange={() => handleSessionTypeChange(`paid_${index}`)
                          // selectedPrice = sess.basecost
                          // }

                          onChange={() => {
                            handleSessionTypeChange(`paid_${index}`);
                            setSelectedPrice(sess.sumcost);
                            setSelectedPlanName(sess.name);
                          }}
                        />
                        <p className="plan-name-text">{sess.name} </p>
                        <p className="plan-price">
                          ₹{sess.sumcost}{" "}
                          {/* <span className="false-cost-para">
                            ₹{sess.false_cost}
                          </span> */}
                        </p>
                        <p className="plan-validity">
                          Validity: {sess.daystime} days
                        </p>
                        <p className="plan-validity">
                          {" "}
                          ₹
                          {sess.max_sessions
                            ? Math.floor(sess.sumcost / sess.max_sessions)
                            : "-"}{" "}
                          per session
                        </p>
                      </label>
                    );
                  })}
              </div>
            </div>
            <>
              {/* <DateInput
                selectedPrice={selectedPrice}
                selectedPlanName={selectedPlanName}
                onDateChange={handleTrialDateChange}
                selectedDateParam={selectedDateParam}
                selectedDateEnableProp={selectedDateEnable}
                // dateDisabled={dateDisabled}
                // startDateAvailable={startDateAvailable}
                // onCheckboxChange={handleCheckboxChange}
              /> */}

              <DateInput
                selectedPrice={selectedPrice}
                selectedPlanName={selectedPlanName}
                onDateChange={handleTrialDateChange}
                selectedDateParam={storeSel?.UrlData?.startDateParam}
                selectedDateEnableProp={storeSel?.UrlData?.startDateParam ? true : false}
                // dateDisabled={dateDisabled}
                // startDateAvailable={startDateAvailable}
                // onCheckboxChange={handleCheckboxChange}
              />
            </>

            {selectedPrice !== null &&
              selectedSessionType &&
              (selectedSessionType.startsWith("trial_") ||
                selectedSessionType.startsWith("paid_")) && (
                <p className="selected-card-price">
                  ₹{selectedPrice}{" "}
                  <span className="plan-name">for {selectedPlanName}</span>
                </p>
              )}
          </form>

          <div className="home-buy-button-parent">
            <div className="home-page-price-div">
              {/* <p>₹{sessionTrialContent[selectedTrialOption]?.sumcost}</p> */}
              {/* <p><del>₹{sessionTrialContent[selectedTrialOption]?.false_cost}</del></p> */}
            </div>
            {(selectdate !== "" && storeSel.UrlData.startDateParam !== "") &&
            selectedSessionType ? (
              <button type="submit" onClick={navigateTo} className="btn">
                Start Now
              </button>
            ) : (
              <button disabled className="btn disable-btn">
                Start Now
              </button>
            )}
          </div>
        </div>

        <GreyLine />
        {/* <div className="home-scroll-content">
          <h4 className="sub-heading-home">ABOUT THIS PLAN</h4>
          <p>{getContentData(props.appname).aboutPlan.content}</p>
          <h4 className="sub-heading-home">CANCELLATION</h4>
          <p
            dangerouslySetInnerHTML={{
              __html: getContentData(props.appname).cancellationContent.content,
            }}
          ></p>
          <GreyLine />
          <h4 className="sub-heading-home">HOW IT WORKS</h4>
          <p
            dangerouslySetInnerHTML={{
              __html: getContentData(props.appname).howItWorksContent.content,
            }}
          ></p>
        </div> */}
      </div>
    </>
  );
};

export default HomeContentNew;

// sessionUtils.js

export const getSessionDetails = (selectedSessionType, sessionTrialContent, sessionContent, selectedTrialOption, selectedOption) => {
  const isTrial = selectedSessionType.startsWith("trial_");
  const daysTime = isTrial
    ? sessionTrialContent[selectedTrialOption]?.daystime
    : sessionContent[selectedOption]?.daystime;

  return { isTrial, daysTime };
};

